import { get } from 'lodash';
export default function getLatLng() {
  let address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return address.lat_lng !== undefined ? get(address, 'lat_lng', []) : [get(address, 'latitude', []), get(address, 'longitude', [])];
}
//# sourceMappingURL=getLatLng.js.map